var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { selectKeyPath } from '@mdpp/od-belt';
import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { useDetectOutsideClick } from '../../../../../hooks';
import { DragAndDropComponent } from './DragAndDropComponent';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n"], ["\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n"])));
var Img = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
export function ODImageFileInput(props) {
    var formikContext = useFormikContext();
    var _a = React.useState(false), isUploadViewOpen = _a[0], setIsUploadViewOpen = _a[1];
    var _b = React.useState(''), blobUrl = _b[0], setBlobUrl = _b[1];
    var dndRef = React.useRef(null);
    useDetectOutsideClick(function () { return setIsUploadViewOpen(false); }, dndRef, isUploadViewOpen);
    var name = props.name, width = props.width, height = props.height, keyPath = props.keyPath, _c = props.style, style = _c === void 0 ? function () { return ({}); } : _c, renderNoneImage = props.renderNoneImage, render = props.render, _d = props.validate, validate = _d === void 0 ? function () { return true; } : _d, accept = props.accept;
    var _e = formikContext || {}, errors = _e.errors, touched = _e.touched, setFieldValue = _e.setFieldValue, handleBlur = _e.handleBlur, _f = _e.values, values = _f === void 0 ? {} : _f, isSubmitting = _e.isSubmitting;
    var imgProps = { width: width, height: height };
    var v = values;
    var link = blobUrl || selectKeyPath(keyPath)(v, '');
    var image = React.useMemo(function () {
        if (render) {
            var rendered = render(link, v);
            if (rendered !== false) {
                return rendered;
            }
        }
        return link ? (React.createElement(Img, __assign({ style: { width: width, height: height }, alt: name, src: link }, imgProps))) : (React.createElement(Img, __assign({ alt: "empty", src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", style: { width: width, height: height } }, imgProps)));
    }, [name, link, width, height, imgProps, render]);
    var handleChange = React.useCallback(function (file, bUrl) {
        var _a, _b;
        if (!(_b = (_a = validate) === null || _a === void 0 ? void 0 : _a(file), (_b !== null && _b !== void 0 ? _b : true))) {
            return;
        }
        setBlobUrl(bUrl);
        setFieldValue(name, file);
    }, [name, setBlobUrl, setFieldValue]);
    return (React.createElement(Wrapper, { style: __assign({ width: width, height: height + 2, border: isUploadViewOpen ? '0' : undefined }, style(!!link)), ref: dndRef, onDragEnter: function () { return setIsUploadViewOpen(true); }, onClick: function () { return setIsUploadViewOpen(true); } },
        React.createElement(DragAndDropComponent, { accept: accept, style: { width: width, height: height }, isOpen: isUploadViewOpen, onChange: handleChange, onClose: function () { return setIsUploadViewOpen(false); }, onDragLeave: function () { return setIsUploadViewOpen(false); }, toggle: function () { return setIsUploadViewOpen(function (value) { return !value; }); } }),
        !link && renderNoneImage && renderNoneImage(),
        (link || !renderNoneImage) && image));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=ODImageFileInput.js.map